<section class="how-it-works-section">
  <div class="how-it-works-container">
    <div class="how-it-works-content">
      <!-- Header Section -->
      <div class="how-it-works-header">
        <h2 class="how-it-works-heading">{{ headlineKey | translateLang }}</h2>
        <div class="eyebrow-heading">
          <span class="eyebrow-text">{{ eyebrowTextKey | translateLang }}</span>
        </div>
      </div>

      <!-- Steps Section -->
      <div class="how-it-works-steps">
        @for (step of steps; track step.icon; let i = $index) {
          <div class="step-card">
            <div class="step-icon-wrapper">
              <div class="step-icon" [class.yellow-bg]="step.hasYellowBackground && !stepIconUrls[i]">
                @if (stepIconUrls[i]) {
                  <img [src]="stepIconUrls[i]" class="step-custom-icon" alt="">
                } @else {
                  <mat-icon [svgIcon]="step.icon" class="icon"></mat-icon>
                }
              </div>
            </div>
            <div class="step-text">
              <h3 class="step-title">{{ step.titleKey | translateLang }}</h3>
              <p class="step-description">{{ step.descriptionKey | translateLang }}</p>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</section>
